import type { Appointment } from '@medplum/fhirtypes'
import {
  SELF_PAY_COVERAGE_REFERENCE,
  SELF_PAY_STATUS_EXTENSION_URL,
  SELF_PAY_STATUS_VALUES,
  type SelfPayStatus,
} from '@/model/middleware-types'

export function isSelfPayAppointment(appointment: Appointment): boolean {
  return (appointment.supportingInformation ?? []).some(
    (entry) => entry.reference === SELF_PAY_COVERAGE_REFERENCE,
  )
}

/** The real Coverage attached to the visit, if any — the self-pay marker is never one. */
export function attachedCoverageReference(appointment: Appointment): string | undefined {
  return appointment.supportingInformation?.find(
    (entry) =>
      entry.reference?.startsWith('Coverage/') && entry.reference !== SELF_PAY_COVERAGE_REFERENCE,
  )?.reference
}

export function readSelfPayStatus(appointment: Appointment): SelfPayStatus | null {
  const value = appointment.extension?.find(
    (extension) => extension.url === SELF_PAY_STATUS_EXTENSION_URL,
  )?.valueCode

  return (SELF_PAY_STATUS_VALUES as readonly string[]).includes(value ?? '')
    ? (value as SelfPayStatus)
    : null
}
